import { styled } from '@mui/material';

export const DishesWrapper = styled('div')({
  filter: 'brightness(100%)',
  paddingTop: '3em',
});

export const HeaderDishes = styled('div')({
  filter: 'brightness(100%)',
  color: 'white',
});
export const Swiper = styled('div')({
  filter: 'brightness(100%)',
});

export const TitleDishes = styled('h2')({
  color: 'white',
});

export const UnderLine = styled('div')({
  border: '3px solid #e96a43',
  borderRadius: '15px',
  marginLeft: 'auto',
  marginRight: 'auto',
  justifyContent: 'center',
  width: '10%',
});

export const MainColor = styled('span')({
  color: '#e96a43',
});

export const SpanSLideTitle = styled('div')({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: '700',
  letterSpacing: '1px',
  height: '35px',
  position: 'relative',
  top: '310px',
  background: 'rgba(37, 37, 37, 0.87)',
  color: 'white',
});
